import React from 'react';
import { archivedIcon } from '@/constants/images';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const ArchiveActionMenu = ({ onClick, disabled, isArchival }) => (
  <RibbonMenu
    className="aridhia-archive-action-menu"
    disabled={disabled}
    icon={archivedIcon(isArchival)}
    message={isArchival ? 'actions.archive' : 'actions.restore'}
    name="archive"
    onClick={onClick}
    titleMessage={isArchival ? 'status.archive.hover' : 'status.restore.hover'}
  />
);

export default ArchiveActionMenu;
